module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_3-15acbf9ed284cf9b53d9b2cfbcd2d686.jpg";